export function isInvalidInt(value) {
    return value < -999999999999999 || 999999999999999 < value;
}
//# sourceMappingURL=isInvalidInt.js.map